import { Injectable } from '@angular/core';

export enum StepperMode {
  AgentMode = 'Agent',
  ClientMode = 'Client'
}
@Injectable({
  providedIn: 'root' // ensures it's a singleton across the app
})
export class StepperContextService {
  private _isDialog = false;
  private _isPreApproval = false;
  private _agentId = ''
  private _clientToken = ''
  private _loanId = ''
  private _mode = StepperMode.AgentMode
  private _clientInfo = {}
  private _clientExternalId = ''
  private _isBeta = false;

  private _purposePrepopulated = false;

  set clientToken(value: string) {
    this._clientToken = value;
  }

  get clientToken(): string {
    return this._clientToken;
  }

  set isDialog(value: boolean) {
    this._isDialog = value;
  }

  get isDialog(): boolean {
    return this._isDialog;
  }

  set isPreApproval(value: boolean) {
    this._isPreApproval = value;
  }

  get isPreApproval(): boolean {
    return this._isPreApproval;
  }

  set purposePrepopulated(value: boolean) {
    this._purposePrepopulated = value;
  }

  get purposePrepopulated(): boolean {
    return this._purposePrepopulated;
  }

  set agentId(value: string) {
    this._agentId = value;
  }

  get agentId(): string {
    return this._agentId;
  }

  set loanId(value: string) {
    this._loanId = value;
  }

  get loanId(): string {
    return this._loanId;
  }

  set mode(value: StepperMode) {
    this._mode = value;
  }

  get mode(): StepperMode {
    return this._mode;
  }

  set clientInfo(value: any) {
    this._clientInfo = value;
  }

  get clientInfo(): any {
    return this._clientInfo;
  }

  set clientExternalId(value: string) {
    this._clientExternalId = value;
  }

  get clientExternalId(): string {
    return this._clientExternalId;
  }

  get isBeta(): boolean {
    return this._isBeta;
  }

  set isBeta(value: boolean) {
    this._isBeta = value;
  }
  clear() {
    this._isDialog = false;
    this._purposePrepopulated = false;

    this._agentId = ''
    this._clientToken = ''
    this._loanId = ''
    this._mode = StepperMode.AgentMode
    this._clientInfo = {}
    this._clientExternalId = ''
  }
}